import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import RolesContainer from '../../components/roles/RolesContainer';

const RolesPage = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.isSuperuser && !me?.role?.changePermission) navigate('/');
  }, [me, me?.isSuperuser, me?.role?.changePermission, navigate])

  return (
    <Box>
      <RolesContainer />
    </Box>
  )
}

export default RolesPage;
